<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      <div class="login-card login-dark">
        <div>
          <div>
            <a class="logo" routerLink="/">
              <img class="img-fluid for-light" src="../../../../assets/images/logo/logo-fe.svg" alt="looginpage" />
              <img class="img-fluid for-dark" src="../../../../assets/images/logo/logo-fe.svg" alt="looginpage" />
            </a>
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="loginForm">
              <h4>Sign in to account</h4>
              <p>Enter your email & password to login</p>
            
              <div class="form-group">
                <label class="col-form-label">Email Address</label>
                <input class="form-control" type="email" required placeholder="app@yourmail.com" formControlName="email" 
                       [ngClass]="{'is-invalid': loginForm.controls.email.touched && loginForm.controls.email.invalid}" />
            
                <div *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.required" class="text text-danger mt-1">
                  Email is required
                </div>
                <div *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.email" class="text text-danger mt-1">
                  Invalid Email
                </div>
              </div>
            
              <div class="form-group">
                <label class="col-form-label">Password</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password" required placeholder="*********" 
                       [ngClass]="{'is-invalid': loginForm.controls.password.touched && loginForm.controls.password.invalid}" />
                       <div class="show-hide" (click)="showPassword()" *ngIf="!show"> 
                        <i class="fa fa-eye"></i> 
                      </div>
                      <div class="show-hide" (click)="showPassword()" *ngIf="show">
                        <i class="fa fa-eye-slash"></i> 
                      </div>
            
                <div *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required" class="text text-danger mt-1">
                  Password is required
                </div>
                <div *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.minlength" class="text text-danger mt-1">
                  Password must be at least 6 characters long
                </div>
              </div>
            
              <div class="form-group mb-0">
                <div class="checkbox p-0">
                  <input id="checkbox1" type="checkbox" />
                  <label class="text-dark" for="checkbox1">Remember password</label>
                </div>
                <a [routerLink]="'/authentication/forgot-password'" class="link">Forgot password?</a>
                
                <div class="text-end mt-3">
                  <button class="btn btn-primary d-block w-100" [disabled]="!loginForm.valid" (click)="login()" type="button">
                    <span>Sign in</span>
                  </button>
                </div>
              </div>
            
              <p class="mt-4 mb-0 text-center">
                Don't have an account?
                <a [routerLink]="'/authentication/register/signup'" class="ms-2">Create Account</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
